/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import categoriesData from "../jsons/categories.json";

const Sidebar = ({ open, onClose }) => {
  const [expanded, setExpanded] = useState(false);
  const [currentSubcategories, setCurrentSubcategories] = useState([]);

  const handleCategoryHover = (subcategories) => {
    setExpanded(true);
    setCurrentSubcategories(subcategories);
  };

  const handleModalClose = () => {
    setExpanded(false);
    onClose();
  };

  useEffect(() => {
    if (!open) {
      setExpanded(false);
    }
  }, [open]);

  return (
    <Modal open={open} onClose={handleModalClose}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: expanded ? 600 : 300,
          height: "auto",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          overflow: "auto",
          mt: "128px",
        }}
      >
        <Box sx={{ width: 300 }}>
          <List>
            {categoriesData.map((category) => (
              <ListItem
                button
                key={category.id}
                onMouseEnter={() => handleCategoryHover(category.subcategories)}
              >
                <ListItemText
                  primary={
                    <a
                      href={category.link}
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        cursor: "pointer",
                        ":hover": {
                          textDecoration: "underline",
                          color: "#1976d2", // Blue color on hover
                        },
                      }}
                    >
                      {category.category}
                    </a>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Box>
        {expanded && (
          <>
            <Divider orientation="vertical" flexItem />
            <Box sx={{ width: 300, pl: 2 }}>
              <List>
                {currentSubcategories.map((subcategory, index) => (
                  <ListItem key={index}>
                    <ListItemText
                      primary={
                        <a
                          href={subcategory.link}
                          style={{
                            textDecoration: "none",
                            color: "inherit",
                            cursor: "pointer",
                            ":hover": {
                              textDecoration: "underline",
                              color: "#1976d2", // Blue color on hover
                            },
                          }}
                        >
                          {subcategory.text}
                        </a>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default Sidebar;
